<template>
  <div class="container">
    <div
      class="positon-relative waxon_tm_main_title"
      v-scroll-reveal="{ delay: 40, distance: '30px' }"
    >
      <div class="title">
        <h3>Featured Works<span class="bg">Portfolio</span></h3>
      </div>
      <!-- End shane_tm_title -->
    </div>

    <div v-if="activetab === 1" class="tabcontent">
      <div class="portfolio_inner">
        <ul>
          <CoolLightBox 
            :items="allItems"
            :index="index"
            @close="index = null"
          >
          </CoolLightBox>
          <li v-for="(image, imageIndex) in allItems" :key="imageIndex">
            <div class="list_inner">
              <div class="image" @click="index = imageIndex">
                <img src="../../assets/img/thumbs/1-1.jpg" alt="Portfolio" />
                <div
                  class="main"
                  :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                ></div>
              </div>
              <!-- End .image -->
              <div class="title">
                <h3 @click="index = imageIndex">{{ image.portfolioName }}</h3>
              </div>
            </div>
          </li>
          <!-- End li -->
        </ul>
      </div>

      <!-- End .portfolio_list -->
    </div>
    <!-- End All .tabcontent 1 -->

    <div v-if="activetab === 2" class="tabcontent">
      <div class="portfolio_inner">
        <ul>
          <CoolLightBox
            :items="vimeoItems"
            :index="index"
            @close="index = null"
          >
          </CoolLightBox>
          <li v-for="(image, imageIndex) in vimeoItems" :key="imageIndex">
            <div class="list_inner">
              <div class="image">
                <img src="../../assets/img/thumbs/1-1.jpg" alt="Portfolio" />
                <div
                  class="main"
                  @click="index = imageIndex"
                  :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                ></div>
              </div>
              <!-- End .image -->
              <div class="title">
                <h3 @click="index = imageIndex">{{ image.portfolioName }}</h3>
              </div>
            </div>
          </li>
          <!-- End li -->
        </ul>
        <!-- End .portfolio_list -->
      </div>
    </div>
    <!-- End Vimeo .tabcontent 2 -->

    <div v-if="activetab === 3" class="tabcontent">
      <div class="portfolio_inner">
        <ul>
          <CoolLightBox
            :items="youtubeItems"
            :index="index"
            @close="index = null"
          >
          </CoolLightBox>
          <li v-for="(image, imageIndex) in youtubeItems" :key="imageIndex">
            <div class="list_inner">
              <div class="image">
                <img src="../../assets/img/thumbs/1-1.jpg" alt="Portfolio" />
                <div
                  class="main"
                  @click="index = imageIndex"
                  :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                ></div>
              </div>
              <!-- End .image -->
              <div class="title">
                <h3 @click="index = imageIndex">{{ image.portfolioName }}</h3>
              </div>
            </div>
          </li>
          <!-- End li -->
        </ul>
        <!-- End .portfolio_list -->
      </div>
    </div>
    <!-- End Youtube .tabcontent 3 -->

    <div v-if="activetab === 4" class="tabcontent">
      <div class="portfolio_inner">
        <ul>
          <CoolLightBox
            :items="galleryItems"
            :index="index"
            @close="index = null"
          >
          </CoolLightBox>

          <li v-for="(image, imageIndex) in galleryItems" :key="imageIndex">
            <div class="list_inner">
              <div class="image">
                <img src="../../assets/img/thumbs/1-1.jpg" alt="Portfolio" />
                <div
                  class="main"
                  @click="index = imageIndex"
                  :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                ></div>
              </div>
              <!-- End .image -->
              <div class="title">
                <h3 @click="index = imageIndex">{{ image.portfolioName }}</h3>
              </div>
            </div>
          </li>
          <!-- End li -->
        </ul>
        <!-- End .portfolio_list -->
      </div>
    </div>
    <!-- End Image .tabcontent 4 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      activetab: 1,
      allItems: [
        {
          src: require("../../assets/img/portfolio/1.jpg"),
          thumb: require("../../assets/img/portfolio/1.jpg"),
          portfolioName: "Amazon Robotics",
          description: "While contracted with Amazon Robotics, I worked on a TCP-based communication protocol in C++. The protocol allowed their engineers to remotely train Fanuc arm robots to perform factory tasks. My assignment included thorough unit and integration testing and helped my company earn further contracts.",
        },
        {
          src: require("../../assets/img/portfolio/2video.mp4"),
          thumb: require("../../assets/img/portfolio/2.jpg"),
          portfolioName: "FPGA Image Processing",
          description: "For my undergraduate research, Professor Baas was interested in enabling SDRAM for the DE10-Lite FPGA so that future students could use it in the lab. I wrote skeleton Verilog code to transfer and store an image via JTAG from a computer to the FPGA. This led to an example project, a computer vision image processor that detects edges with a Sobel filter.",
        },
        {
          src: "https://youtu.be/IdtuGJDZ0_I",
          thumb: require("../../assets/img/portfolio/3.jpg"),
          portfolioName: "FPGA Accelerometer Game",
          description: "This Verilog project is built with a Moore state machine. It’s a dodging game that uses an accelerometer to control a spaceship. The player must avoid collisions with variable-sized blocks that move across the screen in a shift register. The game tracks a player's score and is fully configurable and pausable.",
        },
        {
          src: require("../../assets/img/portfolio/4video.mp4"),
          thumb: require("../../assets/img/portfolio/4.jpg"),
          portfolioName: "Autonomous RC Car",
          description: "My team’s car traversed a taped track at 9m/s to take second place in our graduation year. Our artificial intelligence used a microcontroller computer vision algorithm to process image frames and follow the track at the highest speed possible. Adjustments were calculated and fine tuned with a PID controller before being sent via UART to a DC motor and turning servo.",
        },
        {
          src: require("../..//assets/img/portfolio/5.jpg"),
          thumb: require("../..//assets/img/portfolio/5.jpg"),
          portfolioName: "IoT Embedded Image Search",
          description: "This Internet of Things project uses a Universal TV Remote and an IR detector to input strings to a microcontroller. The embedded C RESTful algorithm then sends an HTTP post to Amazon AWS to query Google for the string in a Python Lambda function. The first image found is compressed and returned to be displayed on an OLED via SPI.",
        },
        {
          src: require("../..//assets/img/portfolio/6.jpg"),
          thumb: require("../..//assets/img/portfolio/6.jpg"),
          portfolioName: "Geisel Software Web App",
          description: "A full stack web app to retrieve company data from the Harvest and Quickbooks APIs, process the data, generate insightful company analytics, and demonstrate the results with graphs and charts. The app was built with Django on the backend, NodeJS and jQuery on the frontend, and deployed with Apache.",
        },
      ],
      index: null,
    };
  },
};
</script>

<style lang="scss" scoped></style>
